const filterReserved = (missions) => missions.filter((mission) => mission.reserved);

export default filterReserved;
